<template>
    <section>
        <div class="row">
            <div class="col-md-12">
                <div class="callout callout-info">
                    <h6>
                        Configurar Autenticação em duas etapas</h6>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group">
                <p-radio @change="checkGenerateToken()" v-model="request.two_factory_type" name="2fa" :value="null"
                    :color="appLayout.check">Nenhum
                </p-radio>
                <p-radio @change="checkGenerateToken()" v-model="request.two_factory_type" name="2fa" value="E"
                    :color="appLayout.check">E-mail
                </p-radio>
                <p-radio @change="checkGenerateToken()" v-model="request.two_factory_type" name="2fa" value="G"
                    :color="appLayout.check">Google
                    Authenticator</p-radio>
            </div>
        </div>
        <div class="row">
            <div class="callout callout-danger" v-if="!request.two_factory_type">
                <h6><b><i class="fa fa-exclamation-triangle"></i></b>
                    Nenhuma confirmação será pedida no login!</h6>
            </div>
            <div class="callout callout-success" v-if="request.two_factory_type == 'E'">
                <h6><b><i class="fa fa-envelope-o"></i></b>
                    Será enviado um código via e-mail para confirmar o login</h6>
            </div>
            <div class="col-md-12 text-center" v-if="request.two_factory_secret && request.two_factory_type == 'G'">
                <div class="callout callout-success">
                    <h6><b><i class="fa fa-google"></i></b>
                        Será requisitado o código do autenticador do Google no login</h6>
                </div>
                <small>Use o App Google Authenticator para ler a imagem abaixo</small>
                <img width="180px" :src="request.imageBase64">
                <div class="form-group">
                    <label class="float-left">Secret</label>
                    <input class="form-control form-control-sm" disabled :value="request.two_factory_secret">
                </div>
            </div>
            <div class="col-md-12" v-if="!request.two_factory_secret && request.two_factory_type == 'G'">
                <button @click="generateToken()" class="btn btn-block btn-outline-secondary btn-sm">Gerar Outro
                    Código</button>
            </div>
        </div>
        <br>
        <div class="row">
            <button
                :disabled="((!request.imageBase64 && auth_user.two_factory_type == request.two_factory_type) || (this.request.google_configured && auth_user.two_factory_type == request.two_factory_type))"
                @click="saveSettings()" class="btn btn-block btn-outline-success">Salvar</button>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                request: {
                    token_otp: null,
                    two_factory_type: null,
                    google_configured: false,
                    imageBase64: null,
                    two_factory_secret: null
                }
            }
        },
        beforeMount() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent() {
                this.request.two_factory_type = this.auth_user.two_factory_type;
                this.request.google_configured = this.auth_user.google_configured;
            },
            saveSettings() {
                if (this.request.two_factory_type == 'G') {
                    this.saveTwoFactoryGoogle();
                } else {
                    this.saveTwoFactory();
                }
            },
            saveTwoFactory() {
                Swal.fire({
                    title: this.$t('words.atention'),
                    html: `<p>Alterando a Autenticação em duas etapas</p>
                        <input id="swal-input2" required type="password" class="swal2-input" placeholder="Digite sua senha">
                        <input type="checkbox" id="swal-input1">
                        <label for="swal-input1">Desconectar outras sessões?</label>`,
                    icon: 'warning',
                    allowOutsideClick: true,
                    showCancelButton: true,
                    cancelButtonText: trans('words.cancel'),
                    confirmButtonText: 'Confirmar',
                    confirmButtonClass: 'btn btn-success btn-lg float-right',
                    cancelButtonClass: 'btn btn-default btn-lg float-left',
                    buttonsStyling: false,
                    reverseButtons: true,
                    showLoaderOnConfirm: true,
                    preConfirm: (confirm) => {
                        if (confirm) {
                            this.request.password = document.getElementById('swal-input2').value;
                            this.request.disconect = document.getElementById('swal-input1').checked;
                            if (!this.request.password) {
                                Swal.showValidationMessage('Por favor, informe sua senha.');
                                document.getElementById('swal-input2').classList.add('swal2-inputerror');
                                return false
                            }
                            return this.$store.dispatch('changeTwoFactory', this.request).then(response => {
                                return response;
                            }).catch(error => {
                                Swal.fire({
                                    icon: error.status,
                                    title: 'Ops',
                                    html: error.message,
                                    showCancelButton: true,
                                    confirmButtonClass: 'btn btn-default btn-lg float-right',
                                    cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                                    buttonsStyling: false,
                                    confirmButtonText: 'Fechar',
                                    reverseButtons: true
                                });
                            })
                        }
                    }
                }).then(response => {
                    Swal.fire({
                        icon: response.value.status,
                        title: 'Feito',
                        html: response.value.message,
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-default btn-lg float-right',
                        cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                        buttonsStyling: false,
                        confirmButtonText: 'Fechar',
                        reverseButtons: true
                    });
                    this.$store.dispatch('getUserData').then(r => {
                        this.request = {
                            two_factory_type: null,
                            google_configured: false,
                            imageBase64: null,
                            two_factory_secret: null
                        }
                        this.prepareComponent();
                    });
                }).catch(error => {
                    //console.log(error); // Nice to view which properties 'error' have
                });
            },
            async saveTwoFactoryGoogle() {
                let password = false;
                const steps = [0, 1]
                const swalQueue = Swal.mixin({
                    progressSteps: steps,
                });
                await swalQueue.fire({
                    title: 'Confirme sua senha',
                    html: `<p>Alterando a Autenticação em duas etapas</p>                        
                        <input id="swal-input2" required type="password" class="swal2-input" placeholder="Digite sua senha para continuar">
                        <input type="checkbox" id="swal-input1">
                        <label for="swal-input1">Desconectar outras sessões?</label>`,
                    icon: 'warning',
                    allowOutsideClick: false,
                    showCancelButton: true,
                    cancelButtonText: trans('words.cancel'),
                    confirmButtonClass: 'btn btn-default btn-lg float-right',
                    cancelButtonClass: 'btn btn-default btn-lg float-left',
                    buttonsStyling: false,
                    reverseButtons: true,
                    showLoaderOnConfirm: true,
                    confirmButtonText: 'Avançar >',
                    currentProgressStep: 0,
                    preConfirm: (confirm) => {
                        if (confirm) {
                            this.request.password = document.getElementById('swal-input2').value;
                            this.request.disconect = document.getElementById('swal-input1').checked;
                            if (!this.request.password) {
                                Swal.showValidationMessage('Por favor, informe sua senha.');
                                document.getElementById('swal-input2').classList.add('swal2-inputerror');
                                return false
                            }
                            password = true;
                        }
                    }
                });

                if (!password) {
                    return;
                }
                await swalQueue.fire({
                    title: `Confirme o token do Google Authenticator`,
                    currentProgressStep: 1,
                    html: `<p>Alterando a Autenticação em duas etapas</p>
                        <input id="swal-input3" required type="text" class="swal2-input" placeholder="Digite o token que aparece no aplicativo">`,
                    icon: 'warning',
                    allowOutsideClick: false,
                    showCancelButton: true,
                    cancelButtonText: trans('words.cancel'),
                    confirmButtonText: 'Confirmar',
                    confirmButtonClass: 'btn btn-success btn-lg float-right',
                    cancelButtonClass: 'btn btn-default btn-lg float-left',
                    buttonsStyling: false,
                    reverseButtons: true,
                    showLoaderOnConfirm: true,
                    preConfirm: (confirm) => {
                        if (confirm) {
                            this.request.token_otp = document.getElementById('swal-input3').value;
                             if (!this.request.token_otp) {
                                Swal.showValidationMessage('Por favor, informe o token que aparece no aplicativo.');
                                document.getElementById('swal-input3').classList.add('swal2-inputerror');
                                return false
                            }
                            return this.$store.dispatch('changeTwoFactory', this.request).then(
                                response => {
                                    return response;
                                }).catch(error => {
                                Swal.fire({
                                    icon: error.status,
                                    title: 'Ops',
                                    html: error.message,
                                    showCancelButton: true,
                                    confirmButtonClass: 'btn btn-default btn-lg float-right',
                                    cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                                    buttonsStyling: false,
                                    confirmButtonText: 'Fechar',
                                    reverseButtons: true
                                });
                            })
                        }
                    }
                }).then(response => {
                    Swal.fire({
                        icon: response.value.status,
                        title: 'Feito',
                        html: response.value.message,
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-default btn-lg float-right',
                        cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                        buttonsStyling: false,
                        confirmButtonText: 'Fechar',
                        reverseButtons: true
                    });
                    this.$store.dispatch('getUserData').then(r => {
                        this.request = {
                            two_factory_type: null,
                            google_configured: false,
                            imageBase64: null,
                            two_factory_secret: null
                        }
                        this.prepareComponent();
                    });
                }).catch(error => {
                    //console.log(error); // Nice to view which properties 'error' have
                });
            },
            checkGenerateToken() {
                if (this.request.two_factory_type == 'G' && !this.request.google_configured) {
                    this.generateToken();
                }
            },
            generateToken() {
                this.$store.dispatch('generateGoogleSecret').then(response => {
                    this.request.imageBase64 = response.image_base_64;
                    this.request.two_factory_secret = response.two_factory_secret;
                    this.request.google_configured = false;
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>